export enum Citizenship {
  National = "WNI",
  International = "WNA",
}
